var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRrCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.746,20.334a1,1,0,0,1-.081,1.413l-1.586,1.414A2.9,2.9,0,0,1,15.015,24a3.013,3.013,0,0,1-2.136-.882l-1.544-1.374a1,1,0,0,1,1.33-1.494L14,21.444V14a1,1,0,0,1,2,0v7.445l1.335-1.192A1,1,0,0,1,18.746,20.334Zm-.39-12.973a1.088,1.088,0,0,1-.722-.735,8,8,0,0,0-15.489.842,7.657,7.657,0,0,0,.8,5.18A5.448,5.448,0,0,0,.057,18.3,5.843,5.843,0,0,0,5.683,23H8a1,1,0,0,0,0-2H5.683a3.81,3.81,0,0,1-3.646-2.982,3.469,3.469,0,0,1,1.834-3.6,1.993,1.993,0,0,0,.793-2.685A6,6,0,1,1,15.724,7.22a3.1,3.1,0,0,0,2.045,2.052,5.971,5.971,0,0,1,4.212,6.21,5.377,5.377,0,0,1-1.111,2.909,1,1,0,0,0,1.586,1.219,7.466,7.466,0,0,0,1.52-3.972A7.96,7.96,0,0,0,18.356,7.361Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCloudDownload);
export default __webpack_public_path__ + "static/media/fi-rr-cloud-download.975b3eb9.svg";
export { ForwardRef as ReactComponent };